import * as React from 'react'
import cn from 'classnames'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { H4 } from '../../styles/2024/TextStyles'
import styled from 'styled-components'

export const HamburgerMenu = ({ isOpenMenuNavs, toggleMobileNavs, className = '' }) => {
  const history = useHistory()
  const { pathname } = useLocation()

  const navigate = (url) => {
    toggleMobileNavs()
    history.push(url)
  }

  const isActive = (url) => {
    return pathname === url
  }

  const menuItemClass = (url) =>
    cn('text-beige-yellow w-fit hover:text-comfort-green', {
      'text-comfort-green border-b border-dotted border-comfort-green !font-["reckless_light"]': isActive(url),
    })

  const menuClasses = cn(
    'bg-almost-black transition-all transition-height duration-500 pr-8 pt-8 cursor-pointer',
    {
      '-translate-x-[102vw] opacity-100 h-[100vh] !overflow-hidden': isOpenMenuNavs, // Menu slides in to natural position from right
      'translate-x-full opacity-90 h-[0vh]': !isOpenMenuNavs, // Menu slides out to the right
    },
    className,
  )

  return (
    <div className={cn('relative flex justify-between mb-0 z-50 w-full', className)}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '70px',
          justifyContent: 'space-between',
        }}
      >
        <MenuIcon isOpen={isOpenMenuNavs} onClick={toggleMobileNavs}>
          <Bar className='bg-comfort-green' isOpen={isOpenMenuNavs} />
          <Bar className='bg-comfort-green' isOpen={isOpenMenuNavs} />
          <Bar className='bg-comfort-green' isOpen={isOpenMenuNavs} />
        </MenuIcon>
        <Link to='/2024/search'>
          <img src='/static/2024/svg/search.svg' alt='Search' />
        </Link>
        <div className={menuClasses} style={{ position: 'absolute', width: '101vw', left: 90, top: 42, paddingLeft:'24px' }}>
        <ul className='flex flex-col gap-16'>
          <li onClick={() => navigate('/2024/home')}>
            <H4 className={menuItemClass('/home')}>Home</H4>
          </li>
          <li onClick={() => navigate('/2024/work')}>
            <H4 className={menuItemClass('/2024/work')}>Work</H4>
          </li>
          <li onClick={() => navigate('/2024/grads')}>
            <H4 className={menuItemClass('/2024/grads')}>Graduates</H4>
          </li>
          <li onClick={() => navigate('/2024/events')}>
            <H4 className={menuItemClass('/2024/events')}>Events</H4>
          </li>
          <li onClick={() => navigate('/2024/about')}>
            <H4 className={menuItemClass('/2024/about')}>About</H4>
          </li>
          <li onClick={() => navigate('/2024/letters')}>
            <H4 className={menuItemClass('/2024/letters')}>Letterbox</H4>
          </li>
        </ul>
      </div>
      </div>

    </div>
  )
}

const MenuIcon = styled.div`
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`

const Bar = styled.div`
  height: 3px;
  width: 100%;
  transition: all 0.5s ease;
  border-radius: 3px;

  &:nth-child(1) {
    transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg)' : 'rotate(0)')};
    transform-origin: top left;
  }

  &:nth-child(2) {
    opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
    transform: ${({ isOpen }) => (isOpen ? 'translateX(-20px)' : 'translateX(0)')};
  }

  &:nth-child(3) {
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-45deg)' : 'rotate(0)')};
    transform-origin: bottom left;
  }
`
